// extracted by mini-css-extract-plugin
module.exports = {"DrawerHeader":"styles_DrawerHeader__A4T4s","lineBar":"styles_lineBar__33pX4","DeliveryHeader":"styles_DeliveryHeader__2rth0","divider":"styles_divider__2LAof"};